import { Box, Skeleton } from '@mui/material';
import Grid from '@mui/material/Grid2';

export function LeftColumnSkeleton() {
  return (
    <>
      <Box sx={{ border: '1px solid #ECECEC', p: 2, mb: 2 }}>
        <Skeleton width={200} height={24} />

        {[1, 2].map((i) => (
          <Box key={i} sx={{ mt: 2 }}>
            <Skeleton width='40%' height={16} />
            <Skeleton width='30%' height={14} />

            <Grid container spacing={2} mt={1}>
              {[1, 2, 3].map((j) => (
                <Grid key={j} size={4}>
                  <Skeleton width='80%' height={14} />
                </Grid>
              ))}
            </Grid>
          </Box>
        ))}
      </Box>

      <Skeleton width={80} height={20} />

      {[1, 2, 3].map((i) => (
        <Box key={i} sx={{ my: 1 }}>
          <Skeleton height={16} width='70%' />
          <Skeleton height={12} width={100} />
        </Box>
      ))}

      <Skeleton height={90} sx={{ mt: 2 }} />
      <Skeleton height={40} sx={{ mt: 2 }} />
    </>
  );
}

export function RightColumnSkeleton() {
  return (
    <>
      <Skeleton height={56} sx={{ mb: 2 }} />
      <Skeleton height={64} sx={{ mb: 2 }} />

      <Skeleton width={140} height={20} />
      <Skeleton height={90} sx={{ mb: 2 }} />

      <Skeleton width={100} height={20} />

      {[...Array(5)].map((_, i) => (
        <Skeleton key={i} height={20} sx={{ mt: 1 }} />
      ))}
    </>
  );
}

/** @deprecated Use InteractionLogLeftSkeleton */
export const CallLogLeftSkeleton = LeftColumnSkeleton;

/** @deprecated Use InteractionLogRightSkeleton */
export const CallLogRightSkeleton = RightColumnSkeleton;
